const PermitActionTypes = {
  GET_OPTIONS: "GET_OPTIONS",
  GET_OPTIONS_SUCCESS: "GET_OPTIONS_SUCCESS",
  GET_OPTIONS_FAILURE: "GET_OPTIONS_FAILURE",
  SUBMIT_LEAVE: "SUBMIT_LEAVE",
  SUBMIT_LEAVE_SUCCESS: "SUBMIT_LEAVE_SUCCESS",
  SUBMIT_LEAVE_FAILURE: "SUBMIT_LEAVE_FAILURE",
};

export default PermitActionTypes;
